<script setup lang="ts">
defineEmits<{ start: [] }>()
</script>

<template>
  <div class="issue_diagnosis_intro">
    <p class="issue_diagnosis_intro_eyebrow">2分でわかる マーケティング課題診断</p>
    <h2 class="issue_diagnosis_intro_title">
      14の質問で、貴社の課題と<br>必要な打ち手を整理します。
    </h2>
    <p class="issue_diagnosis_intro_desc">所要2分・その場で結果をご覧いただけます。</p>
    <button type="button" class="issue_diagnosis_intro_btn" @click="$emit('start')">診断をはじめる</button>
  </div>
</template>
